export const Charge = {
  minAmountCredit: 50,
  maxAmountCredit: 500000,
  maxAmount: 9999999,
} as const;
